// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";

export default __t.row({
  creatureId: __t.u64().primaryKey().name("creature_id"),
  denKey: __t.string().name("den_key"),
  species: __t.string(),
  x: __t.f32(),
  z: __t.f32(),
  hp: __t.i32(),
  state: __t.string(),
  targetKind: __t.string().name("target_kind"),
  targetVersona: __t.u64().name("target_versona"),
  targetPlayer: __t.identity().name("target_player"),
  respawnAt: __t.timestamp().name("respawn_at"),
  updatedAt: __t.timestamp().name("updated_at"),
});
